import { Group } from '@common-web/index.js';
import { strings } from '@constants/strings';
import { formatFloatingNumbers, formatNumbers, getFormattedDate } from '@utils/utils.js';
import { Flex } from 'antd';
import { capitalize } from 'lodash';
import { Fragment } from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';

export const VariantsTooltip = ({ variants, product }) => {
  const getOptionNames = (options) => {
    return options?.map((option) => option?.value)?.join(', ');
  };
  const masterVariant = variants?.find((item) => item?.is_master);

  return (
    <Group gap={'6px'} template={'1fr max-content'}>
      <span className="fw-700">Total</span>
      <span className="text-end fw-700">{formatNumbers(product?.total_quantity)}</span>

      {variants?.map((variant) => (
        <Fragment key={variant?.sku}>
          <Flex align="center" gap={2} className="fw-500">
            <span>{variant?.sku || '-'}</span>
            {getOptionNames(variant?.option_values) && <span>-</span>}
            <span>{getOptionNames(variant?.option_values)}</span>
          </Flex>
          <Flex align="center" justify="end" className="fw-700">
            {variant?.available_quantity > 0 ? (
              formatNumbers(variant?.available_quantity)
            ) : (
              <Flex align="center" gap={4} style={{ color: '#FFCE32' }}>
                <RiErrorWarningLine />
                <span>Out of Stock</span>
              </Flex>
            )}
          </Flex>
        </Fragment>
      ))}
    </Group>
  );
};

export const UpdatedAtTooltip = ({ createdAt, createdBy }) => {
  return (
    <Flex align="start" vertical>
      <div>
        <span style={{ color: 'var(--gray-200)' }}>Created at:</span>{' '}
        <span className="fw-700">{getFormattedDate(createdAt)}</span>
      </div>
      {!!createdBy && (
        <div>
          <span style={{ color: 'var(--gray-200)' }}>Created by:</span>{' '}
          <span className="fw-700">{createdBy?.name || '-'}</span>
        </div>
      )}
    </Flex>
  );
};
export const ReasonTooltip = ({ reason }) => {
  return (
    <Flex align="start" vertical style={{ maxWidth: '300px' }}>
      <div>
        <span style={{ color: 'var(--gray-200)' }}>{strings.reason}</span>
        {': '}
        <span className="fw-700">{reason}</span>
      </div>
    </Flex>
  );
};

export const StoreRatingTooltip = ({ avgProductRating }) => {
  return (
    <Flex align="start" vertical>
      <div>
        <span style={{ color: 'var(--gray-200)' }}>{strings.avg_product_rating}</span>{' '}
        <span className="fw-700">{formatFloatingNumbers(avgProductRating, 1)}/5</span>
      </div>
    </Flex>
  );
};
